var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPackage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.6302 8.52014C4.83418 8.52014 5.81019 7.54413 5.81019 6.34015C5.81019 5.13617 4.83418 4.16016 3.6302 4.16016C2.42621 4.16016 1.4502 5.13617 1.4502 6.34015C1.4502 7.54413 2.42621 8.52014 3.6302 8.52014Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.52024 9.97009C5.64023 9.57009 4.66023 9.3501 3.63023 9.3501C2.60023 9.3501 1.62023 9.57009 0.740234 9.97009V13.2701H6.52024V9.97009Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4704 9.45004C20.4704 10.66 19.4904 11.63 18.2904 11.63C17.0904 11.63 16.1104 10.65 16.1104 9.45004C16.1104 8.25004 17.0904 7.27002 18.2904 7.27002C19.4904 7.27002 20.4704 8.25004 20.4704 9.45004Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1804 13.0699C20.3004 12.6699 19.3204 12.45 18.2904 12.45C17.2604 12.45 16.2804 12.6699 15.4004 13.0699V16.3699H21.1804V13.0699Z",
    fill: "current"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1305 2.21002C13.1305 3.42002 12.1505 4.39005 10.9505 4.39005C9.75051 4.39005 8.77051 3.41002 8.77051 2.21002C8.77051 1.01002 9.75051 0.0300293 10.9505 0.0300293C12.1505 0.0300293 13.1305 1.01002 13.1305 2.21002Z",
    fill: "current"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8405 5.82996C12.9605 5.42996 11.9805 5.20996 10.9505 5.20996C9.92055 5.20996 8.94055 5.42996 8.06055 5.82996V9.12997H13.8405V5.82996Z",
    fill: "current"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.48047 14.04H0.730469V20.22H6.48047V14.04Z",
    fill: "current"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8203 9.8501H8.07031V20.2201H13.8203V9.8501Z",
    fill: "current"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1602 17.1301H15.4102V20.2201H21.1602V17.1301Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage);
export default __webpack_public_path__ + "static/media/package.51662e5372cee420e06d20d121115f9e.svg";
export { ForwardRef as ReactComponent };